import { render } from "./ProcessLeadDashboard.vue?vue&type=template&id=59c383f1"
import script from "./ProcessLeadDashboard.vue?vue&type=script&lang=js"
export * from "./ProcessLeadDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__